/**
 * @generated SignedSource<<10a2a6116aef41582aee8bf594d38a4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HotelSource = "ETG" | "TEDO";
import { FragmentRefs } from "relay-runtime";
export type HotelSidebar_hotel$data = {
  readonly source: HotelSource | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "HotelSidebar_hotel";
};
export type HotelSidebar_hotel$key = {
  readonly " $data"?: HotelSidebar_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelSidebar_hotel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelSidebar_hotel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};

(node as any).hash = "9fa3cb57d792b23528a41e4df0167310";

export default node;
